<template>
  <div>
    <div class="arena">
      <div class="slide">
        <mySlide />
      </div>
      <div class="arena-warp">
        <div v-if="fuList.length>0" class="w1500P75">
          <div class="csgo-title">
            <div class="flex flex-ac flex-jc">
              <img src="@/assets/images/title-label.png" />
              <div class="t p-1">限时福利</div>
              <img src="@/assets/images/title-label.png" />
            </div>
          </div>
          <div>
            <div class="list-box flex flex-w flex-jc">
              <div v-for="(item,index) in fuList" :key="item.id" class="li" @click="goDetail(item)">
                <div class="list-warp">
                  <div v-if="item.receive==1" class="time">领取时间 : {{ item.receive_time }}</div>
                  <div style="text-align: center">{{item.title}}</div>
                  <swiper v-if="item.reward_type==1">
                    <swiper-slide v-for="(item1, index1) in item.skin_list" :pagination="{ clickable: true }" :key="index1" class="swiper-slide">
                      <div class="swiper-item" :class="parseColor(item1)">
                        <div class="flex-jc flex flex-ac swiper-item-i-b">
                          <div v-if="item.subclassName" class="subclassName">{{ item1.subclassName }}</div>
                          <img :src="item1.imageUrl" class="">
                        </div>
                        <div class="dot flex-ac flex-jc flex">
                          <div v-for="(s,si) in item.skin_list" :key="si" class="dot-point" :class="{'dot-active':si==index1}"></div>
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <swiper v-else>
                    <swiper-slide class="swiper-slide">
                      <div class="swiper-item">
                        <div class="flex-jc flex flex-ac swiper-item-i-b">
                          <img src="@/assets/images/moneyback.png" class="">
                        </div>
                        <div class="name" style="padding: 10px 0">碎片：{{ item.reward_diamond }}</div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <!-- <div class="num">
                    <div class="money">{{ item.join_type==1?'消费':'充值' }}：<img src="@/assets/images/money.png" class="money-img" />{{ item.join_quota }}( {{ item.progress }}/{{ item.join_quota }})</div>
                    <div class="num-box">
                      <el-progress :percentage="((item.progress/item.join_quota)>1?1:item.progress/item.join_quota)*100" :stroke-width="8" :show-text="false"></el-progress>
                    </div>
                  </div> -->
                  <div class="btn">
                    <div v-if="item.receive==1" class="btn-w-r-bg btn-blue">
                      <div class="btn-c-r">已经领取</div>
                    </div>
                    <div v-else class="btn-w-r-bg" @click.stop="jionRoom(item)">
                      <div v-if="item.completed==0" class="btn-c-r">
                        {{ item.join_type==102?'暂未认证':'立即开启'  }}
                      </div>
                      <div v-else class="btn-c-r">{{ item.reward_type==1 ? '立即开启' : '立即领取' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="list.length>0" class="w1500P75">
          <div class="csgo-title">
            <div class="flex flex-ac flex-jc">
              <img src="@/assets/images/title-label.png" />
              <div class="t p-1">每日免费福利箱子</div>
              <img src="@/assets/images/title-label.png" />
            </div>
            <div class="des">完成每日任务即可解多的免费福利箱子</div>
          </div>
          <div>
            <div class="list-box flex flex-w flex-jc">
              <div v-for="(item,index) in list" :key="item.id" class="li" @click="goDetail(item)">
                <div class="list-warp">
                  <div v-if="item.receive==1" class="time">领取时间 : {{ item.receive_time }}</div>
                  <countdown class="countdown-box" v-else :end-time="item.end_time" @countdown-ended="getNewEndTime">
                  </countdown>
                  <swiper v-if="item.reward_type==1">
                    <swiper-slide v-for="(item1, index1) in item.skin_list" :pagination="{ clickable: true }" :key="index1" class="swiper-slide">
                      <div class="swiper-item" :class="parseColor(item1)">
                        <div class="flex-jc flex flex-ac swiper-item-i-b">
                          <div v-if="item.subclassName" class="subclassName">{{ item1.subclassName }}</div>
                          <img :src="item1.imageUrl" class="">
                        </div>
                        <div class="dot flex-ac flex-jc flex">
                          <div v-for="(s,si) in item.skin_list" :key="si" class="dot-point" :class="{'dot-active':si==index1}"></div>
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <swiper v-else>
                    <swiper-slide class="swiper-slide">
                      <div class="swiper-item">
                        <div class="flex-jc flex flex-ac swiper-item-i-b">
                          <img src="@/assets/images/moneyback.png" class="">
                        </div>
                        <div class="name" v-if="item.reward_diamond != item.reward_diamond_max" style="padding: 10px 0">碎片：{{ item.reward_diamond }} - {{ item.reward_diamond_max }}</div>
                        <div class="name" v-else style="padding: 10px 0">碎片：{{ item.reward_diamond }}</div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="num">
                    <div class="money">{{ item.join_type==1?'消费':'充值' }}：<img src="@/assets/images/money.png" class="money-img" />{{ item.join_quota }}( {{ item.progress }}/{{ item.join_quota }})</div>
                    <div class="num-box">
                      <el-progress :percentage="((item.progress/item.join_quota)>1?1:item.progress/item.join_quota)*100" :stroke-width="8" :show-text="false"></el-progress>
                    </div>
                  </div>
                  <div class="btn">
                    <div v-if="item.receive==1" class="btn-w-r-bg btn-blue">
                      <div class="btn-c-r">已经领取</div>
                    </div>
                    <div v-else class="btn-w-r-bg" @click.stop="jionRoom(item)">
                      <div class="btn-c-r">{{ item.reward_type==1 ? '立即开启' : '立即领取' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="active-box mobilew1500">
          <div class="csgo-title">
            <div class="flex flex-ac flex-jc">
              <img src="@/assets/images/title-label.png" />
              <div class="t p-1">每日任务</div>
              <img src="@/assets/images/title-label.png" />
            </div>
            <div class="des">完成每日任务即可领取免费奖励</div>
          </div>
          <div class="active-box-bottom ">
            <div class="title">
              <img src="@/assets/images/box/seven.png" class="seven-img" />
              <div class="text">赢取神秘饰品和余额奖励</div>
            </div>
            <div class="task-box">
              <swiper ref="task-box-swiper" class="task-box-swiper" :options="swiperOptions" style="width: 100%;">
                <swiper-slide v-for="(item,index) in rewards" :key="item.id" class="task-item" :class="{'task-item1':item.is_sign==1,'task-item3':item.is_sign!=1,'task-item2':index==sign&&today_sign!=1}">
                  <div class="top">
                    <div class="day">第{{ item.day }}天</div>
                    <div class="money money-t">+{{ item.reward }}</div>
                    <img v-if="sign==index && today_sign!=1" src="@/assets/images/box/dqd.png" class="dqd" />
                  </div>
                  <div v-if="item.is_sign==1" class="status-b">
                    <img src="@/assets/images/box/yqd.png" class="yqd" />
                  </div>
                  <div v-else-if="sign==index && today_sign!=1" class="btn-b" @click="handleSignIn">
                    <div class="btn">{{ qualification==0?'今日首充':'立即签到' }}</div>
                    <img src="@/assets/images/box/img-1.png" class="img-1" />
                  </div>
                  <div v-else class="status-b">
                    <img src="@/assets/images/box/dqd.png" class="yqd" />
                  </div>
                </swiper-slide>
                <!-- <swiper-slide class="task-item task-item2">
                  <div class="top">
                    <div class="day">第3天 <span class="money">+0.092</span></div>
                    <div class="money-img-text money-t">
                      <img src="@/assets/images/box/hot.png" class="hot-img" />
                      <span>充值任意金额完成签到 </span>
                    </div>
                    <img src="@/assets/images/box/dqd.png" class="dqd" />
                  </div>
                  <div class="btn-b">
                    <div class="btn">立即充值完成签到</div>
                    <img src="@/assets/images/box/img-1.png" class="img-1" />
                  </div>
                </swiper-slide>
                <swiper-slide class="task-item task-item3">
                  <div class="top">
                    <div class="day">第5天 <span class="money">+0.092</span></div>
                    <div class="money-img-text money-t">
                      <img src="@/assets/images/box/hot.png" class="hot-img" />
                      <span>充值任意金额完成签到 </span>
                    </div>
                  </div>
                  <div class="status-b">
                    <img src="@/assets/images/box/yqd.png" class="yqd" />
                  </div>
                </swiper-slide> -->
              </swiper>
            </div>
          </div>
        </div>
        <!-- <div class="w1500P75">
          <div class="csgo-title">
            <div class="flex flex-ac flex-jc">
              <img src="@/assets/images/title-label.png" />
              <div class="t p-1">活动列表</div>
              <img src="@/assets/images/title-label.png" />
            </div>
            <div class="des">参与活动赢取C52饰品奖险</div>
          </div>
          <div v-for="(typeItem,index) in typeBoxList" :key="typeItem.id" :id="'section'+index" class="center">
            <div class="csgo-box">
              <ul class="flex flex-w flex-jc">
                <li v-for="item in typeItem.box_list" :key="item.id" class="box-hover" @click="openbox(item.id)">
                  <div class="li-div">
                    <div class="bei1">
                      <img :src="item.img_main" class="img_main" />
                      <img :src="item.img_active" class="img_active" />
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="money-warp flex flex-jc flex-ac">
                      <img src="@/assets/images/money.png" class="money-img-text" />
                      <span>{{ item.price }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 动画弹窗 -->
      <div class="kai-box-open csgo-mask flex flex-ac flex-jc" v-if="openBoxState">
        <div class="kai-warp-box">
          <div class="open-line" ref="openLine"></div>
          <div class="kaibox-warp">
            <div class="kaibox-item" v-for="(item, index) in imgList" :key="index">
              <ul :class="['kaibox-ul'+index,openBoxState&&isThree ? 'ul2' :'',openBoxState&&!isThree ? 'ul1' :'']">
                <li v-for="(item1, index1) in item.imgs" :key="index1" :data="item1.name" class="flex-0 flex flex-ac flex-jc">
                  <img :src="item1.imageUrl" class="kaibox-img" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--中奖完成后盒子-->
      <div v-if="winState">
        <mywin :winList="winList" :winState="winState" winStatus="1" @winexchange="winexchange($event)" @winget="winget($event)" @winX="winX($event)"></mywin>
      </div>
      <myhomebot></myhomebot>
    </div>
    <audio controls ref="notify4" class="audio" @play="onPlay" @error="handleAudioError">
      <source src="@/assets/audio/open_box6s.mp3" />
    </audio>
    <audio controls ref="notify" class="audio">
      <source src="@/assets/audio/open_box2.mp3" />
    </audio>
    <div class="commonBg"></div>

  </div>

</template>
<script>
import myhomebot from "@/components/my_homebot.vue";
import countdown from "@/g-components/countdown.vue";
import mySlide from "@/g-components/my_slide.vue";
import { parseColor } from "@/assets/js/util.js";
import mywin from "@/components/my_win.vue";

export default {
  components: { myhomebot, countdown, mySlide, mywin },
  data() {
    return {
      rewards: [],
      sign: 0,
      today_sign: 0,
      qualification: 0,
      parseColor,
      activeName: "first",
      list: [],
      typeBoxList: [],
      fuList: [],
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1
      },
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto'
      },
      boxInfo: {
        name: '',
        content: ''
      },
      showMore: false,
      voiceState: true,
      // 是否开启动画
      isThree: false,
      cartState: true,
      winList: [],
      openBoxState: false,
      winState: false,
    };
  },
  created() {
    this.getSign()
    this.getData()
  },
  methods: {
    getSign() {
      this.$doGet('/api/hall.Sign/reward').then((res) => {
        this.rewards = res.data.rewards
        this.sign = res.data.user.sign
        this.today_sign = res.data.user.today_sign
        this.qualification = res.data.user.qualification
        setTimeout(() => {
          this.$refs['task-box-swiper'].$swiper.slideTo(this.sign, 500, false)
        }, 1000);
      }).catch(() => { })
    },
    handleSignIn() {
      if (this.qualification == 0) {
        this.$message.error('请先完成今日首充')
        return false
      }
      this.$doPost('/api/hall.Sign/signIn').then((res) => {
        this.$message.success('成功签到')
        console.log(res)
        this.$store.commit("getAboutMon", res.data)
        this.getSign()
      }).catch(() => { })
    },
    getData() {
      // 每日福利箱子
      this.$doGet("/api/hall.Activity/list", this.searchForm).then((res) => {
        this.list = res.data.list
      }).catch(() => { })
      // 福利箱子
      this.$doGet("/api/hall.Activity/list", {
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1,
        type: 2
      }).then((res) => {
        this.fuList = res.data.list
      }).catch(() => { })
      // list
    },
    getNewEndTime() {
      this.getData()
    },
    //加
    goDetail(item) {
      if (item.reward_type == 1 && item.reward_ids) {
        this.$router.push({
          path: `/index/Openbox`,
          query: {
            box_id: item.reward_ids,
            type: 'active'
          },
        })
      }
    },
    jionRoom(item) {
      if (item.completed == 0) {
        if (item.join_type == 102) {
          this.$store.commit('setPersonalOpen', 'idCard')
        } else {
          this.$message.warning('请先' + (item.join_type == 1 ? '消费' : '充值') + item.join_quota)
        }
        return false
      }
      if (item.reward_type == 2) {
        this.$doPost("/api/hall.Activity/receive", {
          id: item.id
        }).then((res) => {
          this.loading = false
          this.$message.success('领取成功')
          this.getData()
          console.log(res)
          this.$store.commit("getAboutMon", res.data)
        }).catch(() => {
          this.loading = false
        })
        return false
      }
      // 这边是箱子 领取做的动画
      this.isThree = window.innerWidth < 540
      console.log(this.isThree)
      let imgCopy = JSON.parse(JSON.stringify(item.skin_list))
      let imgCopy2 = []
      for (let i = 0; i < Math.floor(60 / imgCopy.length) + 1; i++) {
        imgCopy2 = [...imgCopy2, ...imgCopy]
      }
      imgCopy2 = imgCopy2.slice(0, 60)
      this.imgList = [{
        zhongIndex: 0,
        imgs: this.getRandomArr(imgCopy2, 60)
      }]
      // console.log(this.imgList)
      // let res = {
      //   data: {
      //     masonry: "0.00",
      //     player_skins_ids: [],
      //     skins_info: [],
      //     total_amount: "814840.19",
      //     total_price: "39.35",
      //   }
      // }
      // let obj = {
      //   box_id: 363,
      //   box_name: "注册免费箱",
      //   color: "#fc7201",
      //   create_time: "2026-02-11 16:06:26",
      //   exteriorName: "崭新出厂",
      //   imageUrl: "https://api.maipifu.com/storage/file/a25a2667a2568b30e7509fc1dbd22cce441a3ea4.png",
      //   img: "https://napi.maipifu.com/storage/csgo/skins/UFAtQml6b24gfCBDb2xkIENlbGwgKEZhY3RvcnkgTmV3KQ==.png",
      //   player_img: "https://napi.maipifu.com/storage/file/93ee96eafbcac9c0df3221f71560e87496ff89cc.png",
      //   player_name: "王丫丫",
      //   rarityColor: "#5E98D9",
      //   shortName: "PP-野牛 | 冷室",
      //   skin_name: "PP-野牛 | 冷室 (崭新出厂)",
      //   subclassName: "PP-野牛",
      //   top: 2,
      //   typeName: "微型冲锋枪",
      //   weight: 3990,
      // }
      // res.data.skins_info.push(obj)
      this.$doPost("/api/hall.Activity/receive", {
        id: item.id
      }).then((res) => {
        this.loading = false
        let skins_info = res.data.skins_info;
        for (let i = 0; i < skins_info.length; i++) {
          skins_info[i].imageUrl = skins_info[i].img
          this.imgList[i].imgs[40] = skins_info[i]
        }
        this.winList = res.data.skins_info
        if (this.cartState && this.voiceState) {
          this.$refs.notify4.currentTime = 0
          this.$refs.notify4.play()
        }
        //是否开启动画
        if (!this.cartState) {
          this.winState = true
          if (this.voiceState) {
            this.playAlarm()
          }
        } else {
          if (!this.voiceState) {
            this.openBoxState = true
            var length = this.winList.length
            setTimeout(() => {
              this.openBoxState = false;
              this.winState = true;
              this.imgList = []
              if (this.voiceState) {
                this.playAlarm()
              }
            }, 6000 + 100 * length)
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    //音乐 结果
    playAlarm() {
      this.$refs.notify4.pause();
      this.$refs.notify.play();
    },
    onPlay() {
      this.openBoxState = true
      var length = this.winList.length
      setTimeout(() => {
        this.openBoxState = false;
        this.winState = true;
        this.imgList = []
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 100 * length)
    },
    // 音频播放事件
    handleAudioError() {
      this.openBoxState = true
      var length = this.winList.length
      setTimeout(() => {
        this.openBoxState = false;
        this.winState = true;
        this.imgList = []
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 100 * length)
    },
    //子组件修改父组件
    winexchange(msg) {
      this.winState = msg;
    },
    winget(msg) {
      this.winState = msg;
    },
    winX(msg) {
      this.winState = msg;
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
  }
};
</script>

<style lang="less" scoped>
.arena {
  min-height: 100vh;
  .slide {
    margin-bottom: 60px;
  }
  .arena-warp {
    padding-top: 24px;
    .list-box {
      .li {
        width: 25%;
        padding: 12px 15px;
        box-sizing: border-box;
        .list-warp {
          padding: 20px;
          border-radius: 8px;
          background-image: url('~@/assets/images/roll/roll-bg.png');
          background-size: 100% 100%;
          overflow: hidden;
          color: #fff;
          box-sizing: border-box;
          .time {
            line-height: 57px;
            text-align: center;
          }
          .countdown-box {
            padding: 10px 0 10px;
          }
          .swiper-item {
            width: 100%;
            // 原来的样式
            .swiper-item-y {
              width: 134px;
              height: 146px;
              margin: 0 auto;
              background-image: url('~@/assets/images/roll/img-bg.png');
              background-size: 100% 100%;
              position: relative;
              .subclassName {
                position: absolute;
                top: 11px;
                left: 11px;
                background-image: url('~@/assets/images/roll/img-3.png');
                background-size: 100% 100%;
                width: 63px;
                height: 19px;
                line-height: 19px;
                text-align: center;
                font-size: 12px;
                overflow: hidden;
                padding: 0 4px;
                box-sizing: border-box;
              }
              img {
                height: 90px;
                max-width: 80%;
              }
            }
            .swiper-item-i-b {
              max-width: 140px;
              aspect-ratio: 1 / 1;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              .subclassName {
                position: absolute;
                top: 11px;
                left: 11px;
                background-image: url('~@/assets/images/roll/img-3.png');
                background-size: 100% 100%;
                width: 63px;
                height: 19px;
                line-height: 19px;
                text-align: center;
                font-size: 12px;
                overflow: hidden;
                padding: 0 4px;
                box-sizing: border-box;
              }
              img {
                height: 75%;
                width: auto;
              }
            }
            .name {
              text-align: center;
              margin-top: -5px;
            }
            .dot {
              margin: 8px 0 0;
              .dot-point {
                width: 4px;
                height: 4px;
                border-radius: 50%;
                margin: 0 2px;
                background-color: rgba(255, 255, 255, 0.4);
                &.dot-active {
                  background: #fff;
                }
              }
            }
            .item1-name {
              font-weight: bold;
              margin-bottom: 8px;
              padding-left: 2px;
            }
            .sort {
              font-size: 12px;
              height: 16px;
              color: #bbb9b9;
              margin-bottom: 9px;
            }
            .price {
              font-size: 12px;
              height: 16px;
              color: #ffc400;
              margin-bottom: 9px;
            }
            &.darkBlue-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/dark_blue.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.babyBlue-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/baby_blue.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.yellow-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/yellow.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.red-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/red.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.lavender-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/lavender.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.eggplant-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/eggplant.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.gray-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/gray.png) no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .num {
            margin: 24px 0;
            .money {
              font-weight: bold;
              font-size: 16px;
            }
            .num-box {
              margin-top: 12px;
            }
          }
          .img {
            margin-top: 20px;
            .img-box {
              width: 30%;
              background-image: url('~@/assets/img/box-skins-blue.jpg');
              background-size: 100% 100%;
              position: relative;
              text-align: center;
              padding: 5px 0;
              // margin-right: 2px;

              img {
                width: auto;
                max-width: 90%;
                height: 45px;
              }
              span {
                position: absolute;
                top: 15px;
                left: 50%;
                margin-left: -25px;
                color: #fff;
                padding: 0 10px;
                border-radius: 20px;
                background-color: rgba(0, 0, 0, 0.3);
                font-size: 10px;
              }
            }
          }
          .btn {
            .btn-warp {
              width: 100%;
              padding: 3px 6px;
              border-radius: 8px 0 8px 0;
              background: rgba(101, 80, 6, 0.6);
              box-sizing: border-box;
              .b {
                cursor: pointer;
                border-radius: 8px 0 8px 0;
                background-color: #ffc400;
                line-height: 54px;
                text-align: center;
                font-size: 16px;
                color: #2b2e3c;
                font-weight: 600;
              }
              &.btn-warp-look {
                background-color: rgba(6, 91, 101, 0.6);
                .b {
                  background: #00f7ff;
                }
              }
            }
          }
        }
      }
    }
  }
  .active-box-bottom {
    margin-top: 36px;
    background: #262728;
    background: url(~@/assets/images/box/bg.png) no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
    color: #ffffff;
    padding: 36px;
    box-sizing: border-box;
    // border: 2px solid #1c3c4d;
    .title {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-bottom: 30px;
      .text {
        width: 144px;
      }
      img {
        width: 318px;
        height: auto;
      }
      .text {
        font-size: 24px;
      }
    }
    .task-box {
      display: flex;
      justify-content: center;
      .task-item {
        background: #393941;
        border-radius: 8px;
        margin-right: 20px;
        width: 133px;
        padding: 30px 0 0px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        .dqd {
          position: absolute;
          top: 0;
          right: 0;
          width: 100px;
          height: auto;
        }
        .day {
          font-size: 20px;
        }
        .money {
          font-size: 24px;
          font-weight: bold;
        }
        .money-t {
          margin-top: 20px;
        }
        .money-img-text {
          font-weight: bold;
          font-size: 16px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }
        }
        .status-b {
          margin-top: 30px;
          padding: 12px 0;
          text-align: center;
          border-top: 1px solid #000002;
          .yqd {
            width: 100px;
            height: auto;
          }
        }
        .btn-b {
          position: relative;
          .btn {
            background: linear-gradient(180deg, #fbdc00 0%, #ffc503 100%);
            border-radius: 18px;
            margin: 30px 24px 0;
            font-weight: bold;
            font-size: 14px;
            color: #2b2e3c;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
          }
          .img-1 {
            width: 52px;
            height: 45px;
            position: absolute;
            top: 14px;
            right: 52px;
          }
        }
        &.task-item1 {
          text-align: center;
        }
        &.task-item3 {
          text-align: center;
          // width: 320px;
          // .top {
          //   padding: 0 24px;
          // }
        }
        &.task-item2 {
          width: 320px;
          background: #2b2e3c;
          text-align: left;
          .top {
            padding: 0 24px;
          }
        }
      }
    }
  }
}
::v-deep .el-progress-bar__outer {
  background: linear-gradient(180deg, #73250b 0%, #a95017 100%);
  border: 2px solid #73250b;
}
::v-deep .el-progress-bar__inner {
  background: linear-gradient(0deg, #ffc400 0%, #fceda7 100%);
}
.audio {
  display: none;
}
</style>
<style>
/* .task-box-swiper {
  max-width: 100% !important;
  width: auto !important;
}
*/
.task-box-swiper .swiper-wrapper {
  /*max-width: 100% !important;*/
  /*justify-content: center;*/
}
</style>

